import {
  guardarDadosUsuario,
  guardarDadosUsuario2,
  obterDadosUsuario2,
} from "./cookies";
import { renovacaoToken } from "./usuario";

export class SessaoExpiradaError extends Error {
  constructor() {
    super("A sessão expirou.");
    this.name = "SessaoExpiradaError";
  }
}

export const isUnauthorizedError = (error: any) =>
  error?.response?.status === 401 ||
  error?.response?.data?.codigo === 401 ||
  String(error?.message || error).includes("401");

const getRefreshTokens = (response: any) => {
  const camposAdicionais =
    response?.data?.camposAdicionais ??
    response?.data?.resultado?.camposAdicionais ??
    response?.data?.response?.data?.camposAdicionais;

  return {
    tokenAcesso: camposAdicionais?.tokenAcesso as string | undefined,
    tokenRenovacao: camposAdicionais?.tokenRenovacao as string | undefined,
  };
};

let renovacaoEmAndamento: Promise<string> | null = null;

const renovarSessao = async () => {
  const dadosUsuario = obterDadosUsuario2();

  if (!dadosUsuario.token || !dadosUsuario.tokenRenovacao) {
    throw new SessaoExpiradaError();
  }

  try {
    const response = await renovacaoToken(
      dadosUsuario.token,
      dadosUsuario.tokenRenovacao
    );
    const { tokenAcesso, tokenRenovacao } = getRefreshTokens(response);

    if (!tokenAcesso || !tokenRenovacao) {
      throw new SessaoExpiradaError();
    }

    guardarDadosUsuario(
      tokenAcesso,
      tokenRenovacao,
      dadosUsuario.email || "",
      dadosUsuario.id || "",
      dadosUsuario.urlAvatar || undefined
    );
    await guardarDadosUsuario2(
      tokenAcesso,
      tokenRenovacao,
      dadosUsuario.email || "",
      dadosUsuario.id || "",
      dadosUsuario.urlAvatar || undefined
    );

    return tokenAcesso;
  } catch (error) {
    if (error instanceof SessaoExpiradaError) {
      throw error;
    }

    throw new SessaoExpiradaError();
  }
};

const obterTokenRenovado = async () => {
  if (!renovacaoEmAndamento) {
    renovacaoEmAndamento = renovarSessao();
  }

  const renovacaoAtual = renovacaoEmAndamento;

  try {
    return await renovacaoAtual;
  } finally {
    if (renovacaoEmAndamento === renovacaoAtual) {
      renovacaoEmAndamento = null;
    }
  }
};

export const executarRequisicaoAutenticada = async <T,>(
  request: (token: string) => Promise<T>
) => {
  const token = obterDadosUsuario2().token;

  if (!token) {
    throw new SessaoExpiradaError();
  }

  try {
    return await request(token);
  } catch (error) {
    if (!isUnauthorizedError(error)) {
      throw error;
    }
  }

  const tokenRenovado = await obterTokenRenovado();

  try {
    return await request(tokenRenovado);
  } catch (error) {
    if (isUnauthorizedError(error)) {
      throw new SessaoExpiradaError();
    }

    throw error;
  }
};
